import { render, staticRenderFns } from "./after-sale.vue?vue&type=template&id=1c08c695&scoped=true"
import script from "./after-sale.vue?vue&type=script&lang=js"
export * from "./after-sale.vue?vue&type=script&lang=js"
import style0 from "./after-sale.vue?vue&type=style&index=0&id=1c08c695&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08c695",
  null
  
)

export default component.exports